import { Flex, Button } from '@mantine/core';
import { DataLoanDefinitionTct } from '@dealstack/shared/lib/generated';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import React, { useRef } from 'react';
import { MantineTable } from '@dealstack/frontend/shared/components/Table/MantineTable/MantineTable.tsx';
import { useLoansTableState } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/Loans/components/LoansTable/useLoansTableState.ts';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon.tsx';

interface Props {
	loans: DataLoanDefinitionTct[];
	isLoading: boolean;
	onEdit: (loan: DataLoanDefinitionTct) => void;
	onAdd: () => void;
}

export const LoanTable = ({ loans, isLoading, onEdit, onAdd }: Props) => {
	const tMipManage = useTranslationMipManage();
	const tableRef = useRef<HTMLDivElement | null>(null);

	const { columns, mantineTableDataOperations } = useLoansTableState({
		onEdit,
	});

	return (
		<Flex direction="column" w="100%">
			<Flex justify="end" pt="1rem" pb="0.5rem">
				<Button onClick={onAdd} leftSection={<Icon variant="plus" size="lg" />}>
					{tMipManage('root.loans.table.add_another')}
				</Button>
			</Flex>
			<MantineTable<DataLoanDefinitionTct>
				getRowId={(row) => row.id}
				tableRef={tableRef}
				columns={columns}
				isLoading={isLoading}
				dataOperations={mantineTableDataOperations}
				data={loans}
				initialState={{
					columnVisibility: {
						id: false,
					},
				}}
				enableRowActions={false}
				enablePagination={false}
				enableTopToolbar={false}
				enableFilters={false}
				enableGlobalFilter={false}
				enableRowSelection={false}
				manualPagination={false}
			/>
		</Flex>
	);
};
